import { render, staticRenderFns } from "./OctFormGroup.vue?vue&type=template&id=3b3d7684&scoped=true&"
import script from "./OctFormGroup.vue?vue&type=script&lang=js&"
export * from "./OctFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./OctFormGroup.vue?vue&type=style&index=0&id=3b3d7684&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3d7684",
  null
  
)

export default component.exports